export enum BatchTransactionErrors {
    UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
    MISSING_CALLBACK_URL = 'MISSING_CALLBACK_URL',
    MISSING_BATCH_ID = 'MISSING_BATCH_ID',
    DUPLICATE_BATCH_ID = 'DUPLICATE_BATCH_ID',
    MISSING_MERCHANT_TRANSACTION_ID = 'MISSING_MERCHANT_TRANSACTION_ID',
    INVALID_BATCH_ID = 'INVALID_BATCH_ID',
    INVALID_API_VERSION = 'INVALID_API_VERSION',
    VALIDATION_GENERAL_FAILURE = 'VALIDATION_GENERAL_FAILURE',
    XSS_EXCEPTION = 'XSS_EXCEPTION',
    TRANSACTION_TYPE_NOT_ALLOWED = 'TRANSACTION_TYPE_NOT_ALLOWED',
}
